export class LoadMenuPlacement {
  static readonly type = '[MenuPlacement type listing] Load MenuPlacement via Service';
  constructor() {}
}
